export default "One last thing I want to talk about. Our eyes work the same way.\n"